import { Action, Dispatch } from "redux";
import fetchWithUuid from "./fetchWithUuid";
import checkError from "./checkError";
import {
  actionTypes,
  apiStatuses,
  FetchUserInfo,
  fetchUserInfoDeferred,
  productInfoDeferred, userLoggedInDeferred,
  validationErrors
} from "./Actions";

const fetchUserInfo: FetchUserInfo = (
  spidId,
  sig,
  serverTime,
  expiresIn
) => (dispatch: Dispatch<Action>) => {
  const failedCallback = (data: any) => {
    if (
      data.status === 403 &&
      JSON.stringify(data).indexOf(
        validationErrors.USER_AGREEMENT_NOT_ACCEPTED
      ) !== -1
    ) {
      data.acceptedAgreement = false;
      dispatch({
        data,
        status: apiStatuses.SUCCESS,
        type: actionTypes.FETCH_USER_INFO
      });
    } else {
      dispatch({
        data,
        status: apiStatuses.ERROR,
        type: actionTypes.FETCH_USER_INFO
      });
    }
    return fetchUserInfoDeferred.reject(data);
  };

  dispatch({ type: actionTypes.FETCH_USER_INFO, status: apiStatuses.LOADING });

  if (!spidId || !sig || spidId === 'null') {
    dispatch({
      status: apiStatuses.VALIDATION_ERROR,
      type: actionTypes.FETCH_USER_INFO
    });
    fetchUserInfoDeferred.reject('No spidId or sig given.');
    return fetchUserInfoDeferred.promise;
  }

  const now = new Date();
  const nowAsEpoch = (now.getTime() - now.getMilliseconds()) / 1000;
  if (serverTime && expiresIn && nowAsEpoch > serverTime + expiresIn) {
    dispatch({
      status: apiStatuses.VALIDATION_ERROR,
      type: actionTypes.FETCH_USER_INFO
    });
    fetchUserInfoDeferred.reject('Token expired');
    return fetchUserInfoDeferred.promise;
  }

  productInfoDeferred.promise
    .then(productInfo => {
      return fetchWithUuid(
        `/bestilling/c/${productInfo.owningClient}/api/v2/ff/users/${spidId}.json`,
        {
          headers: {
            'x-score-spid-sig': sig
          }
        }
      );
    }, failedCallback)
    .then(checkError)
    .then(res => res.json())
    .then(data => {
      dispatch({
        data,
        status: apiStatuses.SUCCESS,
        type: actionTypes.FETCH_USER_INFO
      });
      userLoggedInDeferred.resolve({ spidId, sig });
      return fetchUserInfoDeferred.resolve(data);
    })
    .catch(failedCallback);
  return fetchUserInfoDeferred.promise;
};

export default fetchUserInfo;
